import { useAuth } from '../context/AuthContext'
import { ROLE_DEFAULT_CAPABILITIES, type Capability } from '../lib/services/capabilities'

/** Map frontend role back to DB role for capability lookup */
const FRONTEND_TO_DB_ROLE: Record<string, string> = {
  Staff: 'user',
  Surveyor: 'editor',
  Admin: 'admin',
  Reviewer: 'user', // reviewers have no default capabilities
  FieldSurveyor: 'field_surveyor',
}

/**
 * Check if the current user has a given capability.
 * Checks role defaults first, then granted_capabilities from ViewerContext.
 */
export function useHasCapability(capability: Capability): boolean {
  const { viewerContext } = useAuth()
  if (!viewerContext) return false

  // Superadmin has all capabilities
  if (viewerContext.is_superadmin) return true

  // Check role defaults
  const dbRole = FRONTEND_TO_DB_ROLE[viewerContext.role] ?? 'user'
  const defaults = ROLE_DEFAULT_CAPABILITIES[dbRole] ?? []
  if (defaults.includes(capability)) return true

  // Check explicit grants
  return viewerContext.granted_capabilities?.includes(capability) ?? false
}
